import {Modal} from 'antd';

export const showSpotOpenedModal = () => {
  Modal.info({
    className: 'spot-opened-modal',
    title: 'A spot is now available',
    content: 'A spot is now available. The waiting list has been emailed.',
    okText: 'OK',
    centered: true,
  });
};
